import React, { Fragment, useEffect } from 'react';
import './Beneficiaries.scss';
import BeneficiaryDataCardGroupSection from './BeneficiaryDataCardGroupSection';

const BeneficiariesDataCardGroup = (props) => {
  const {
    beneficiaryCardsData: { generalInvestment, individualRetirement },
    handleAddBeneficiary,
    handleHeaderCTA,
    handleManageBeneficiary,
    setSelectedGroup,
    setAgreementsForBeneUpdate,
    setRegistrationKeyForMismatchUpdate,
    handleTODAccounts,
  } = props;

  useEffect(() => {
    // Your code here
  }, []);

  return (
    <Fragment>
      {generalInvestment && generalInvestment.length > 0 && (
        <BeneficiaryDataCardGroupSection
          title="General Investment"
          data={generalInvestment}
          setAgreementsForBeneUpdate={setAgreementsForBeneUpdate}
          setRegistrationKeyForMismatchUpdate={setRegistrationKeyForMismatchUpdate}
          handleHeaderCTA={handleHeaderCTA}
          handleAddBeneficiary={handleAddBeneficiary}
          setSelectedGroup={setSelectedGroup}
          handleManageBeneficiary={handleManageBeneficiary}
          handleTODAccounts={handleTODAccounts}
        />
      )}
      {individualRetirement && individualRetirement.length > 0 && (
        <BeneficiaryDataCardGroupSection
          title="Individual Retirement"
          data={individualRetirement}
          setAgreementsForBeneUpdate={setAgreementsForBeneUpdate}
          handleHeaderCTA={handleHeaderCTA}
          handleAddBeneficiary={handleAddBeneficiary}
          setSelectedGroup={setSelectedGroup}
          handleManageBeneficiary={handleManageBeneficiary}
          setRegistrationKeyForMismatchUpdate={setRegistrationKeyForMismatchUpdate}
          handleTODAccounts={handleTODAccounts}
        />
      )}
    </Fragment>
  );
};

BeneficiariesDataCardGroup.propTypes = {};

export default BeneficiariesDataCardGroup;
